module.exports = __webpack_public_path__ + "static/logo-us-coc@2x-fe5ed1e52cfe0da92cfaaafe3fa567c6.png";